import { Adress } from "./urlList";

export enum CookieOptions {
	auth = "auth",
}
export interface Cookies {
	auth: string;
}
export interface FtpOptions {
	urlFtp: string;
	userFtp: string;
	passFtp: string;
	portFtp: string;
}

export interface DataResponse {
	type: number;
	path: string;
	name: string;
	size: number;
	icon?: string;
}

export interface ErrorFtp {
	error: {
		massage: string;
	};
}
export interface hawMany {
	files: number;
	folders: number;
}

interface Props {
	setConnect: (v: boolean) => void;
	path: string;
	setPath: (v: string) => void;
	setLoadingProgress: (e: number | null) => void;
}

export const paramsQuery = (path?: string, name?: string) => {
	path = path?.replace("//", "/");
	const params = new URLSearchParams();
	if (path) params.append("path", path);
	if (name) params.append("name", name);
	params.append("auth", readCookies().auth);

	return params.toString();
};

export const getSmallImage = async (name: string, path: string) => {
	try {
		const params = paramsQuery(path);
		const data = await fetch(`${Adress.smallImage}/?${params}`, {
			method: "GET",
		});
		const result = await data.json();
		return result.msg;
	} catch (error) {
		return "";
	}
};

export const hawManyFiles = (data: DataResponse[]) => {
	let folders = 0,
		files = 0;
	if (data.length !== 0) {
		data.map((e) => {
			if (e.type === 2) folders++;
			if (e.type === 1) files++;
			return null;
		});
	}
	return { files, folders } as hawMany;
};
export const sortData = async (data: DataResponse[]) => {
	if (data.length !== 0) {
		const folderList = data.filter((e) => e.type === 2);
		const fileList = data.filter((e) => e.type === 1);
		const allData = [...folderList, ...fileList];
		return allData;
	} else {
		return [];
	}
};

export const sortDataByName = async (data: DataResponse[]) => {
	if (data.length !== 0) {
		const folderList = data.filter((e) => e.type === 2);
		const fileList = data.filter((e) => e.type === 1);
		const sortedFolders = folderList.sort((a, b) => {
			if (a.name.toLocaleUpperCase() < b.name.toLocaleUpperCase()) {
				return -1;
			} else if (a.name.toLocaleUpperCase() > b.name.toLocaleUpperCase()) {
				return 1;
			}
			return 0;
		});
		const sortedFiles = fileList.sort((a, b) => {
			if (a.name.toLocaleUpperCase() < b.name.toLocaleUpperCase()) {
				return -1;
			} else if (a.name.toLocaleUpperCase() > b.name.toLocaleUpperCase()) {
				return 1;
			}
			return 0;
		});
		const sortedData = [...sortedFolders, ...sortedFiles];

		return sortedData;
	} else {
		return [];
	}
};

export const readList = async (props: Props): Promise<DataResponse[] | []> => {
	let data: DataResponse[] = [];

	try {
		const resData = await fetch(`${Adress.readList}/?${paramsQuery(props.path)}`);
		if (resData.status === 200) {
			const result = await resData.json();
			props.setPath(result[1]);
			props.setConnect(true);
			data = result[0];
			return data;
		} else {
			props.setPath("");
			props.setConnect(false);

			return [];
		}
	} catch (e) {
		console.log(e);
		props.setPath("");
		props.setConnect(false);
		return [];
	}
};
export const clearCookies = async (): Promise<void> => {
	document.cookie = "auth=;";
};

export const readCookies = (): Cookies => {
	const cookie = decodeURIComponent(document.cookie);
	const myCookie = {
		[CookieOptions.auth]: "",
	};
	if (cookie.length === 0) {
		return myCookie;
	}
	const cookieTab = cookie.split(";");

	for (let i = 0; i < cookieTab.length; i++) {
		while (cookieTab[i].charAt(0) === " ") {
			cookieTab[i] = cookieTab[i].substring(1);
		}
		const newCookieTab: string[] = cookieTab[i].split("=");

		if (newCookieTab[1] !== "undefined") {
			if (newCookieTab[0] === CookieOptions.auth) {
				myCookie[newCookieTab[0]] = newCookieTab[1];
			}
		}
	}
	return myCookie;
};

export const saveCookie = (name: string, value: string): void => {
	document.cookie = `${name}=${value}`;
};

export const saveFtpOptions = async (data: FtpOptions): Promise<void> => {
	await fetch(`Adress.ftpOptions/?${paramsQuery()}`, {
		method: "POST",

		body: JSON.stringify(data),
	});
};

export const getFtpOptions = async () => {
	const data = await fetch(`${Adress.ftpOptions}/?${paramsQuery()}`);
	if (data.status === 200) {
		return await data.json();
	} else {
		return { urlFtp: "", portFtp: "", userFtp: "", passFtp: "" };
	}
};

export const downloadFile = async (fetchResult: any, name: string) => {
	const data = await fetchResult.blob();
	const blob = new Blob([data], { type: data.type || "application/octet-stream" });
	const blobURL = window.URL.createObjectURL(blob);
	const tempLink = document.createElement("a");
	tempLink.style.display = "none";
	tempLink.href = blobURL;
	tempLink.setAttribute("download", name);
	if (typeof tempLink.download === "undefined") {
		tempLink.setAttribute("target", "_blank");
	}
	document.body.appendChild(tempLink);
	tempLink.click();
	document.body.removeChild(tempLink);
	setTimeout(() => {
		window.URL.revokeObjectURL(blobURL);
	}, 100);
};
